// @ts-nocheck

const heroContainers = document.querySelectorAll('[data-has-video-toggle="true"]');

heroContainers.forEach((container) => {
  const mediaGrid = container.querySelector('.hero__media-grid');
  if (!mediaGrid) return;

  // Slot 1 is the markup already in the grid; the remaining slots live inside
  // <template id="hero-media-slot-N"> elements, collected in numeric order.
  const templates = Array.from(container.querySelectorAll('template[id^="hero-media-slot-"]')).sort(
    (a, b) => Number(a.id.replace(/\D/g, '')) - Number(b.id.replace(/\D/g, ''))
  );
  const slots = [mediaGrid.innerHTML, ...templates.map((template) => template.innerHTML)];

  if (slots.length < 2) return;

  const indicatorBars = Array.from(container.querySelectorAll('.hero__slider-indicator__bar'));
  const setActiveBar = (index) => {
    if (!indicatorBars.length) return;
    const active = index % indicatorBars.length;
    indicatorBars.forEach((bar, i) => bar.classList.toggle('is-active', i === active));
  };

  let currentSlot = 0;

  container.addEventListener('click', (e) => {
    if (e.target.closest('a')) return;

    e.preventDefault();
    e.stopPropagation();

    // Pause videos before swap
    mediaGrid.querySelectorAll('video').forEach((video) => {
      video.pause();
    });

    currentSlot = (currentSlot + 1) % slots.length;

    // Swap content
    mediaGrid.innerHTML = slots[currentSlot];

    // Play videos if present
    mediaGrid.querySelectorAll('video').forEach((video) => {
      video.play().catch(() => {});
    });

    setActiveBar(currentSlot);
  });
});
